// korns/src/pages/Products/Products.main.js
import MiniDrawer from "../../components/Menu/Drawer";
import { Box } from "@mui/system";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Routes, Route, useNavigate } from "react-router-dom";
import NewProduct from "./NewProduct";
import Product from "./Components/Product";
import useSave from "../../Hooks/useSave";
import IconMenu from "../../components/subMenu/SubMenu";
import { Paper } from "@mui/material";
import ProductGroups from "./ProductGroups";
import ProductList from "./Products";
import Pricelists from "./Pricelists";
import Pricelist from "./Pricelist";
import NewPricelist from "./NewPricelist";
import Labels from "./Labels";
import PricelistReport from "./PricelistReport";
import ProductCreate from "./ProductCreate";

function Products() {
  const navigate = useNavigate();

  const menuHeader = {
    icon: "",
    name: "Products",
  };

  const menu = [
    {
      link: "/products/product-groups",
      path: "/product-groups",
      name: "Product Groups",
      component: ProductGroups,
    },
    {
      link: "/products/products",
      path: "/products",
      name: "Products",
      component: ProductList,
    },
    {
      link: "/products/labels",
      path: "/labels",
      name: "Labels",
      component: Labels,
    },
    {
      link: "/products/pricelists",
      path: "/pricelists",
      name: "Pricelists",
      component: Pricelists,
    },
  ];

  return (
    <MiniDrawer sx={{ margin: "150px", height: "100vh" }} key="1">
      {() => (
        <>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              overflow: "hidden",
            }}
          >
            {/* <IconMenu menuHeader={menuHeader} menu={menu} /> */}

            <Routes>
              {menu.map((item, index) => (
                <Route
                  key={index}
                  path={item.path}
                  element={
                    <>
                      <IconMenu menuHeader={menuHeader} menu={menu} />
                      <item.component />
                    </>
                  }
                />
              ))}
              <Route path="/pricelists/pricelist/:id" element={<Pricelist />} />
              <Route path="/products/new" element={<ProductCreate />} />
              <Route
                path="/pricelists/pricelist/report/:id"
                element={<PricelistReport />}
              />
              <Route
                path="/new-product"
                element={
                  <Paper
                    sx={{
                      width: "100%",
                      height: "auto",
                      padding: "20px",
                      overflow: "auto",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <Button
                      variant="outlined"
                      sx={{ margin: "0px auto 20px 0px  " }}
                      onClick={() => navigate("/products/product-groups")}
                    >
                      <ArrowBackIcon />
                      Back
                    </Button>
                    <NewProduct />
                  </Paper>
                }
              />
              <Route path="/product/:id/*" element={<Product />} />
            </Routes>
          </Box>
        </>
      )}
    </MiniDrawer>
  );
}

export default Products;
